<template>
  <div>
    <base-card>
      <div v-if="Object.keys(business).length">
        <div class="tw-flex tw-justify-between tw-items-center">
          <div>
            <div class="tw-text-gray-600 tw-text-xs tw-font-normal tw-mb-1">Status</div>
            <base-badge v-if="business.hasConnectedAccount" color="green">Connected</base-badge>
            <base-badge v-else color="red">Not Connected</base-badge>
          </div>
          <base-button color="red" type="flat" @click="$refs.disconnectStripeModal.show()" v-if="business.hasConnectedAccount">Disconnect</base-button>
        </div>
      </div>
      <div class="tw-flex tw-justify-between tw-items-center" v-else>
        <div>
          <base-skeleton-loader class="tw-h-2 tw-w-10 tw-mt-1" />
          <base-skeleton-loader class="tw-h-4 tw-mt-3 tw-mb-1 tw-w-32" />
        </div>
        <base-skeleton-loader class="tw-h-3 tw-w-12" />
      </div>
    </base-card>
    <disconnect-stripe-modal ref="disconnectStripeModal" @disconnected="$emit('reload')" :business="business" />
  </div>
</template>

<script>
import DisconnectStripeModal from "@/views/admin/business/components/DisconnectStripeModal";

export default {
  components: {
    DisconnectStripeModal,
  },
  props: {
    business: Object,
  },
};
</script>
